import { GenericService } from '@/services/api/generic.service';
import { User } from '@/models';

export class OrganisationLensSupportUserService extends GenericService<User> {
  constructor(organisationId: string) {
    super(`/menicon/v1/expert-mode/organisations/${organisationId}/lens-support-users`);
  }
}
